// extracted by mini-css-extract-plugin
export default {"spinner":"BlogManageScreen_spinner__NULTi","container":"BlogManageScreen_container__4VWcF","contentWrapper":"BlogManageScreen_contentWrapper__xSjEU"};